import { Component, EventEmitter, ChangeDetectionStrategy, Input, Output } from '@angular/core';
import { ProjectDetailService } from '@shared/components/scheduler-calendar/services/project-detail.service';
import { ItemModel } from 'collection';

@Component({
  selector: 'unscheduled-project-menu',
  templateUrl: './unscheduled-project-menu.component.html',
  styleUrls: ['./unscheduled-project-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnscheduledProjectMenuComponent {
  @Input() dropDate: any;
  @Input() dragData: any;
  @Input() dropPoint: any;

  @Output() closeMenuEmit = new EventEmitter();
  @Output() saveProject = new EventEmitter();

  updateProjectItem: ItemModel;

  updateSelectedDate(e, type) {
    if (type === 'end_date' && e < this.dragData.start_date) {
      this.dragData.start_date = this.dragData.end_date = this.dropDate = e;
      return;
    }

    if (type === 'start_date' && e > this.dragData.end_date) {
      this.dragData.start_date = this.dragData.end_date = this.dropDate = e;
      return;
    }

    this.dragData[type] = e;
  }

  closeMenu(): void {
    this.closeMenuEmit.emit();
  }

  saveChangesToProject(isSubproject?) {
    this.closeMenuEmit.emit();
    this.saveProject.emit(isSubproject ? isSubproject : null);
  }

  constructor(private _projectDetailService: ProjectDetailService) {
    this.updateProjectItem = this._projectDetailService.updateProjectItem;
  }
}
